import {
  MetricSummaryCard,
  type MetricSummaryCardProps,
} from '../MetricSummaryCard/MetricSummaryCard';

/**
 * Figma `972:20768`.
 *
 * The supporting line lost Overview's "the chart further down this page" and
 * names the card instead. The sentence was true of Overview and would have been
 * a guess anywhere else — a report holding this figure need not also hold the
 * history, and a card cannot see what else is on the page with it.
 */
export function TotalMentionsCard(props: MetricSummaryCardProps) {
  return (
    <MetricSummaryCard
      {...props}
      copy={{
        title: 'Total mentions',
        helpText:
          'Every mention of the brand and its monitored keywords across all connected sources.',
        helpSupportingText:
          'Counts, not reach: one post read by a million people is one mention. Mention volume over time is the same figure as a history.',
      }}
    />
  );
}
